import React from "react";
import { Stack, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function AboutCalender() {
  return (
    <Stack direction="row">
      <Box component="img" src="/assets/image12.png" sx={{ width: "50%" }} />
      <Stack justifyContent="center" sx={{ pl: "3%" }}>
        <Typography sx={{ fontFamily: "Helvetica", fontSize: "20px" }}>
          NEXT 1,000 MEMBERSHIPS
        </Typography>
        <Typography
          sx={{ fontFamily: "Helvetica", fontSize: "50px", lineHeight: 1.2 }}
        >
          TUESDAY
        </Typography>
        <Typography
          sx={{ fontFamily: "Helvetica", fontSize: "50px", lineHeight: 1.2 }}
        >
          04.08.22
        </Typography>
        <Typography
          sx={{ fontFamily: "Helvetica", fontSize: "50px", lineHeight: 1.2 }}
        >
          6 PM GMT
        </Typography>
        <Typography
          sx={{
            fontFamily: "Helvetica",
            fontSize: "20px",
            textDecorationLine: "underline",
          }}
        >
          Add to your calender
        </Typography>
      </Stack>
    </Stack>
  );
}
